import { FC } from 'react';
import { AllieFilterBarDesktop } from './FilterBar.desktop';
import { AllieFilterBarMobile } from './FilterBar.mobile';
import type { TooltipAlignment, TooltipSide } from '../../../components/DarkTooltip';


export interface Filter {
  label: string;
  getOptions?: (labelAll: string) => { text: string; value: string }[];
  component?: React.ReactNode;
  handleChange: (e: any) => void;
  selected: string | number | number[] | string[];
  disabled?: boolean;
  multiple?: boolean;
  cssClass?: string;
  type?: 'searchable' | 'select';
  interfaceOptions?: any;
  includeAllOption?: boolean;
  filterLabelAll?: string;
  searchPlaceholder?: string;
  showTooltip?: boolean;
  tooltipText?: string;
  tooltipSide?: TooltipSide;
  tooltipAlignment?: TooltipAlignment;
  virtualized?: boolean;
  'data-testid'?: string;
}

export interface FilterBarProps {
  filters: Filter[];
  labelAll: string;
  labelMultiple?: string;
  labelFilterBy?: string;
  isDesktop?: boolean;
  className?: string;
  style?: React.CSSProperties;
  fullWidth?: boolean;
}

export const AllieFilterBar: FC<FilterBarProps> = ({ isDesktop, ...props }) => {
  const FilterBarPlatform = isDesktop ? AllieFilterBarDesktop : AllieFilterBarMobile;

  return <FilterBarPlatform {...props} />;
};
